import React from 'react';

import "./System.scss"
class System extends React.Component {
	constructor(props) {
		super(props); 
    }

	render() {
        return (
            <div className="systemSection section">
                <h1 className="center">System Summary</h1>

                <div className="photo">
                    <img
                        src={require("assets/img/SystemDiagram.png")}
                    />
                </div>

                <div className="Split5050">
                    <div className="side">
                        <div>Power</div>
                        <ul>
                            <li><p>Solar Energy - 21 W Solar Panel</p></li>
                            <li><p>72 Hour Battery Life 26,800 mAh Battery Pack</p></li>
                            <li><p>Safe Shutdown</p></li>
                        </ul>

                        <div>Chasis</div>
                        <ul>
                            <li><p>Water, Dust Resistant Body</p></li>
                        </ul>
                        <div>Enviroment Detection Node (EDC)</div>
                        <ul>
                            <li><p>Air Temperature</p></li>
                            <li><p>Humidity</p></li>
                            <li><p>Soil Temperature</p></li>
                            <li><p>Soil Moisture</p></li>
                            <li><p>Wind Speed</p></li>
                            <li><p>Atmospheric Pressure</p></li>
                            <li><p>Solar Radiation</p></li>
                            <li><p>Location</p></li>
                        </ul>
                        <div>Wireless Comunication (COM)</div>
                        <ul>
                            <li><p>NRF24L01 Transceiver</p></li>
                            <li><p>2.4 GHz Radio Frequency</p></li>
                            <li><p>End-to-End Encryption</p></li>
                        </ul>
                    </div>
                    <div className="side">
                        <div>Hub</div>
                        <ul>
                            <li><p>Intermediary between the farm and the server</p></li>
                            <li><p>Receives data from EDC nodes, stores it temporarily, and uploads to the server</p></li>
                        </ul>
                        <div>Server</div>
                        <ul>
                            <li><p>Microsoft Azure</p></li>
                            <li><p>Tomcat Server </p></li>
                            <li><p>Java Spring Boot</p></li>
                            <li><p>Microsoft SQL</p></li>
                            <li><p>Assisted Machine Learning</p></li>
                                <ul>
                                    <li><p>Multi Linear Regression</p></li>
                                    <li><p>Neural Network</p></li>
                                </ul>
                        </ul>

                        <div>User Interface (UI)</div>
                        <ul>
                            <li><p>React Web UI</p></li>
                            <li><p>Responsive Design</p></li>
                            <li><p>Dark Mode</p></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
}}

export default System;